<div class="position-relative">
    <div class="container d-xs-flex align-items-xs-center space-top-2 space-top-sm-2 space-xs-0 min-height-xs-100vh">
        <div class="row pt-10 pb-5">
            <div class="col-12 mb-2 mb-lg-0">
                <h1>National Parks of Tanzania</h1>
                <h2 class="text-fg mb-4">Six national parks, dozens of ecosystems, and hundreds of species await your
                    arrival!</h2>
                <p>Northern Tanzania is unique in that 5+ safari destinations are accessible by vehicle, all in under a
                    week's time. Each national park offers unique opportunity, and most of the Kopa itineraries visit a
                    variety of the parks.</p>
                <p>Want to learn more about each? Browse our interactive map, and click-in on any national park to learn
                    more!</p>
            </div>
        </div>

        <div class="row space-bottom-2 px-lg-2">
            <!-- Park List -->
            <div class="col-12 col-lg-4 mb-8 mb-lg-0">
                <div class="list-group">
                    <span class="text-fg list-group-item list-group-item-action active bg-alt">
                        <strong style="font-size:160%">National Parks</strong> available for tour:
                    </span>
                    <button type="button" *ngFor="let park of nationalParkBoundaries; let i = index;"
                            (click)="onMouseClick(park)"
                            class="list-group-item list-group-item-action bg-alt text-fg" style="font-size:100%">{{park.name}}<span
                            class="dot ml-2" [ngStyle]="{'background-color': park.fillColor}"></span></button>
                </div>
            </div>
            <!-- End Park List -->

            <!-- Google Map -->
            <div class="col-12 col-lg-8">
                <agm-map [latitude]="mapLat" [longitude]="mapLng" [styles]="googleMapStyles" [zoom]="isMobile()">
                    <agm-polygon #agmInstance *ngFor="let park of nationalParkBoundaries"
                                 [paths]="park.points"
                                 [strokeColor]="park.fillColor"
                                 [fillColor]="park.fillColor"
                                 [strokeWeight]="strokeWeight"
                                 (polyClick)="onMouseClick(park)"
                                 (polyMouseOver)="onMouseOver(infoWindow, agmInstance, park)"
                                 (polyMouseOut)="onMouseOut(infoWindow, park)">
                        <agm-info-window [disableAutoPan]="true" [latitude]="park.tooltipOrigin.lat"
                                         [longitude]="park.tooltipOrigin.lng" #infoWindow>
                            <div>
                                <span class="text-primary mr-3">{{park.name}}</span>
                            </div>
                        </agm-info-window>
                    </agm-polygon>
                    <agm-marker
                            [latitude]="airportLat"
                            [longitude]="airportLng"
                            (mouseOver)="onMarkerMouseOver(airportTooltip)"
                            (mouseOut)="onMarkerMouseOut(airportTooltip)"
                            [iconUrl]="{ url: './assets/svg/icons/plane.svg', scaledSize: { width: 40, height: 40 }, anchor: { x: 20, y: 0 } }"
                    >
                        <agm-info-window [disableAutoPan]="true" [latitude]="airportLat" [longitude]="airportLng"
                                         #airportTooltip>
                            <div>
                                <span class="text-primary mr-3 clearfix d-none d-md-block"> Kilimanjaro International Airport (JRO)</span>
                                <span class="text-primary mr-3 clearfix d-block d-md-none"> Airport (JRO)</span>
                            </div>
                        </agm-info-window>
                    </agm-marker>
                </agm-map>
            </div>
            <!-- End Google Map -->
        </div>
    </div>
</div>
